import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BusinessappsModel } from 'Pages/orders'
import { DivisionModel } from 'Pages/registratorCabinet'

export type TariffsState = {
	divisions: DivisionModel[]
	regions: { code: string; name: string }[]
	businessApp: BusinessappsModel
}

export const tariffsInitialState: TariffsState = {
	divisions: [],
	regions: [],
	businessApp: null,
}

export namespace TariffsNS {
	export type GetDivisions = PayloadAction<{ region_code?: string; query?: string }>
	export type SetDivisions = PayloadAction<DivisionModel[]>
	export type ClearDivisions = PayloadAction

	export type GetRegions = PayloadAction
	export type SetRegions = PayloadAction<{ code: string; name: string }[]>
	export type ClearRegions = PayloadAction

	export type GetBusinessApp = PayloadAction<{ okved_codes: string; status: string }>
	export type SetBusinessApp = PayloadAction<BusinessappsModel>
	export type ClearBusinessApp = PayloadAction
}

export const tariffsSlice = createSlice({
	name: 'tariffs',
	initialState: tariffsInitialState,
	reducers: {
		getDivisions: (state, action: TariffsNS.GetDivisions) => {},
		setDivisions: (state, action: TariffsNS.SetDivisions) => {
			state.divisions = action.payload
		},
		clearDivisions: (state, action: TariffsNS.ClearDivisions) => {
			state.divisions = []
		},
		getRegions: (state, action: TariffsNS.GetRegions) => {},
		setRegions: (state, action: TariffsNS.SetRegions) => {
			state.regions = action.payload
		},
		clearRegions: (state, action: TariffsNS.ClearRegions) => {
			state.regions = []
		},
		getBusinessApp: (state, action: TariffsNS.GetBusinessApp) => {},
		setBusinessApp: (state, action: TariffsNS.SetBusinessApp) => {
			state.businessApp = action.payload
		},
		clearBusinessApp: (state, action: TariffsNS.ClearBusinessApp) => {
			state.businessApp = null
		},
	},
})
